import {
  Student,
  TeacherClass,
  TeacherInfo,
} from "../../../../../store/onboarding/types";
import React, { Component } from "react";
import { InputGroup, Modal, Spinner } from "react-bootstrap";
import DataFileReader from "../../../../../containers/onboarding/FileReader";
import ColumnHeaderSelector from "../upload-student-data/ColumnHeaderSelector";
import Table from "react-bootstrap/Table";
import UploadStudentsRosterManual from "./UploadStudentsRosterManual";
import Form from "react-bootstrap/Form";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import UserAvatarSmall from "../../../UserAvatarSmall";
import { toastr } from "react-redux-toastr";
import { UserAssignmentRole } from "../../../../../store/auth/types";

library.add(faFile, faPencilAlt);

type PropsFromState = {
  originalFileName: string;
  columnsNames: Array<string>;
  rawData: Array<any>;
  isLoading: boolean;
  fileInputKey?: number;
  error?: any;
  selectedTeacher?: TeacherInfo;
  isStudentRosterUploaded?: boolean;
  newStudents?: number[];
  currentRole?: UserAssignmentRole;
  isFromStudentRoster?: boolean;
};

type DispatchProps = {
  onHide: () => any;
  assignClassToTeacher?: (
    id: number,
    className: string,
    students: Array<Student>
  ) => any;
  updateTeacherClass?: (teacherId: number, updatedClass: TeacherClass) => any;
  assignStudentsToTeacher?: (id: number, students: Array<Student>) => any;
  addStudents?: (students: Array<Student>, addStudentsToEvidence?: boolean, isStudentRosterUploaded?: boolean) => any;
  clearAddStudentsError?: () =>  any;
  openFileUploadErrorModal?: (message: any) => void;
};

type OwnProps = {
  onEnter?: () => any;
  isClass?: boolean;
  className?: string;
  selectedClass?: TeacherClass;
  show: boolean;
};

type Props = OwnProps & PropsFromState & DispatchProps;

type State = {
  className: string;
  // selectedStudentIdColumn: string;
  // selectedFirstNameColumn: string;
  // selectedLastNameColumn: string;
  selectedColumnNames: Array<string>;
};

const STATIC_COLUMNS = ["Student ID", "First Name", "Last Name"];
class UploadStudentsRosterModal extends Component<Props, State> {
  emptyState: State = {
    className: "",
    // selectedStudentIdColumn: "",
    // selectedFirstNameColumn: "",
    // selectedLastNameColumn: "",
    selectedColumnNames: [],
  };

  state: Readonly<State> = this.emptyState;

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>
  ): void {
    if (prevProps.isLoading && !this.props.isLoading) {
      if (!this.props.error) {
        if (this.props.isStudentRosterUploaded) {
          const successcount = this.props.newStudents!.length;
          if (successcount && successcount > 0) {
            toastr.success(
              "Success",
              `Student roster uploaded successfully! ${successcount} new student(s) added.`
            );
            this.props.onHide();
          } else if(window.location.pathname.includes("/data") || window.location.pathname.includes("/district-data")  ) {
            toastr.success(
              "Success",
              "Student roster uploaded successfully."
            );
            this.props.onHide();
          } else {
            toastr.error(
              "Alert",
              "All students in the uploaded roster are already in the system. No new entries added."
            );
          }
        }
      } else {
        if (this.props.isStudentRosterUploaded) {
          if(Array.isArray(this.props.error)) {
            if(JSON.stringify(this.props.error).includes('tab_name')) {
              this.props.openFileUploadErrorModal!(this.props.error)
            } else {
              toastr.error('Failed', this.props.error?.[0])
              // Clear the error from the Redux store
              this.props.clearAddStudentsError?.();
            }
          } else {
            toastr.error('Failed', this.props.error);
            // Clear the error from the Redux store
            this.props.clearAddStudentsError?.();
          }
        }
      }
    }

    if (this.props.fileInputKey !== prevProps.fileInputKey) {
      if (
        this.props.originalFileName &&
        this.props.isFromStudentRoster &&
        this.props.rawData.length > 0
      ) {
        this.setState(
          {
            ...this.emptyState,
            selectedColumnNames: this.props.columnsNames,
          },
          () => this.handleStudentsAdd()
        );
      }
    }
  }

  validateColumnNames = (columns: string[]) => {
    let errors: string = "";
    // Check for missing or misspelled columns
    STATIC_COLUMNS.forEach((col, idx) => {
      if (!columns[idx] || columns[idx] !== col) {
        // Check if the column exists elsewhere (wrong sequence)
        const foundIdx = columns.findIndex(
          (c) => c === col
        );
        if (foundIdx === -1) {
          errors = `Some column names in your file don't match the required format. 
            Please review the roster upload criteria and correct any misspellings. `;
        }
      }
    });
    return errors;
  };

  handleStudentsAdd = () => {
    const { selectedTeacher, rawData, isClass } = this.props;
    const { selectedColumnNames, className } = this.state;
  
    // Validate columns
    const errors = this.validateColumnNames(selectedColumnNames);
    if (errors.length > 0) {
      toastr.error("Failed", errors);
      return;
    }
    const keyMap = ["unique_id", "first_name", "last_name"];
    
    const students: Array<Student> = rawData.map((row) => {
      const student: any = {};
      STATIC_COLUMNS.forEach((col, idx) => {
        const colIndex = selectedColumnNames.findIndex(
          (c) => c.toLowerCase() === col.toLowerCase()
        );
        student[keyMap[idx]] = colIndex !== -1 ? row[selectedColumnNames[colIndex]] || "" : "";
      });
      return student;
    });
    if (selectedTeacher) {
      if (isClass) {
        if (this.props.selectedClass) {
          this.props.updateTeacherClass!(selectedTeacher.user.id, {
            ...this.props.selectedClass,
            students: [...this.props.selectedClass!.students, ...students],
          });
        } else {
          this.props.assignClassToTeacher!(
            selectedTeacher.user.id,
            className,
            students
          );
        }
      } else {
        this.props.assignStudentsToTeacher!(selectedTeacher.user.id, students);
      }
    } else {
      this.props.addStudents!(students, true, true)
      .catch((error:string) => {
        console.error("Error adding students:", error);
      });
    }
  };

  handleChange = () => (event: React.SyntheticEvent) => {
    const { name, value } = event.target as HTMLInputElement;
    this.setState((prevState: State) => {
      const selectedColumnNames = [
        ...prevState.selectedColumnNames.filter(
          (columnName: string) => (prevState as any)[name] !== columnName
        ),
        value,
      ];
      return {
        ...prevState,
        [name]: value,
        selectedColumnNames: selectedColumnNames,
      };
    });
  };

  handleModalOnEnter = () => {
    if (this.props.onEnter) this.props.onEnter();
    this.setState({
      className: this.props.className || "",
      // selectedStudentIdColumn: "",
      // selectedFirstNameColumn: "",
      // selectedLastNameColumn: "",
      selectedColumnNames: [],
    });
  };

  handleClassNameChange = (event: React.FormEvent<any>) => {
    const { name, value } = event.target as HTMLInputElement;
    this.setState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  handleModalClose = () => {
    const { onHide, isLoading } = this.props;
    if (!isLoading) {
      onHide();
    }
  };

  render() {
    const {
      // originalFileName,
      // rawData,
      show,
      isClass,
      //columnsNames,
    } = this.props;
    // const {
    //   // selectedStudentIdColumn,
    //   // selectedFirstNameColumn,
    //   // selectedLastNameColumn,
    //   selectedColumnNames,
    //   className,
    // } = this.state;
    // const columnsIsSelected =
    //   selectedStudentIdColumn &&
    //   selectedFirstNameColumn &&
    //   selectedLastNameColumn;
    return (this.props.selectedTeacher && isClass) || !isClass ? (
      //@ts-ignore
      <Modal
        animation={false}
        show={show}
        size="lg"
        backdropClassName="customDarkModalBackdrop in"
        onHide={this.handleModalClose}
        //@ts-ignore
        onShow={this.handleModalOnEnter}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          className="purpleModalHeader orangeModalHeader"
        >
          <Modal.Title>
            {isClass
              ? this.props.selectedClass
                ? `Add Students to ${this.props.selectedClass.name}`
                : `Create Class For ${
                    this.props.selectedTeacher!.user.first_name
                  } ${this.props.selectedTeacher!.user.last_name}`
              : "Upload Roster"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UploadStudentsRosterManual />
          {
          // !originalFileName ? (
          // <UploadStudentsRosterManual />
          // ) : (
            // <>
            //   <div className="text-center">
            //     {isClass && this.props.selectedTeacher && (
            //       <>
            //         <UserAvatarSmall
            //           userInfo={this.props.selectedTeacher.user}
            //         />
            //         <h3 className="d-inline">
            //           &nbsp;
            //           {`${this.props.selectedTeacher.user.first_name} ${this.props.selectedTeacher.user.last_name}`}
            //         </h3>
            //       </>
            //     )}

            //     <h2>Great, you uploaded:</h2>

            //     <div>
            //       <FontAwesomeIcon icon="file" />
            //       <h4 className="font-weight-bold d-inline">
            //         &nbsp;{originalFileName}
            //       </h4>
            //       <h5>
            //         It has {rawData.length} rows. &nbsp;
            //         <label className="clickableLabel">
            //           Click here to pick a different file.
            //           <DataFileReader />
            //         </label>
            //       </h5>
            //     </div>
            //     <br />

            //     {isClass && !this.props.selectedClass && (
            //       <InputGroup className="mb-3">
            //         <InputGroup.Prepend>
            //           <InputGroup.Text>Class Name</InputGroup.Text>
            //         </InputGroup.Prepend>
            //         <Form.Control
            //           name="className"
            //           value={className}
            //           onChange={this.handleClassNameChange}
            //         />
            //         <InputGroup.Append>
            //           <InputGroup.Text>
            //             <FontAwesomeIcon icon={faPencilAlt} />
            //           </InputGroup.Text>
            //         </InputGroup.Append>
            //       </InputGroup>
            //     )}

            //     <p className="text-left font-weight-bold">
            //       Tell us the column header (label) you want to use for each
            //       field below.
            //     </p>

            //     <div className="text-left">
            //       <div className="form-group row">
            //         <div className="col-sm-6">
            //           <ColumnHeaderSelector
            //             required
            //             name={"selectedFirstNameColumn"}
            //             title={"Student First Name Column"}
            //             value={selectedFirstNameColumn}
            //             onChange={this.handleChange()}
            //             columnNames={columnsNames}
            //             selectedColumnNames={selectedColumnNames}
            //           />
            //         </div>
            //       </div>

            //       <div className="form-group row">
            //         <div className="col-sm-6">
            //           <ColumnHeaderSelector
            //             required
            //             name={"selectedLastNameColumn"}
            //             title={"Student Last Name Column"}
            //             value={selectedLastNameColumn}
            //             onChange={this.handleChange()}
            //             columnNames={columnsNames}
            //             selectedColumnNames={selectedColumnNames}
            //           />
            //         </div>
            //       </div>

            //       <div className="form-group row">
            //         <div className="col-sm-6">
            //           <ColumnHeaderSelector
            //             required
            //             name={"selectedStudentIdColumn"}
            //             title={"Student ID Column"}
            //             value={selectedStudentIdColumn}
            //             onChange={this.handleChange()}
            //             columnNames={columnsNames}
            //             selectedColumnNames={selectedColumnNames}
            //           />
            //         </div>
            //       </div>
            //     </div>
            //     <hr className="wideMargin" />
            //     {columnsIsSelected && (
            //       <>
            //         <h6 className="font-weight-bold text-left">
            //           {" "}
            //           Roster preview
            //         </h6>
            //         <Table className="stdTable">
            //           <thead>
            //             <tr>
            //               <th>NAME</th>
            //               <th>STUDENT ID</th>
            //             </tr>
            //           </thead>
            //           <tbody>
            //             {rawData.map((element: any, index) => (
            //               <tr key={index}>
            //                 <td>{`${element[selectedFirstNameColumn]} ${element[selectedLastNameColumn]}`}</td>
            //                 <td>{element[selectedStudentIdColumn]}</td>
            //               </tr>
            //             ))}
            //           </tbody>
            //         </Table>
            //       </>
            //     )}
            //   </div>

            //   <div className={"text-right"}>
            //     <button className="blueBtnMd" onClick={this.handleStudentsAdd}>
            //       Save{" "}
            //       {this.props.isLoading && (
            //         <Spinner animation="border" size="sm" />
            //       )}
            //     </button>
            //   </div>
            // </>
          // )
          }
        </Modal.Body>
      </Modal>
    ) : null;
  }
}

export default UploadStudentsRosterModal;
